import React from 'react'
import styes from "../Pages/PagesStyles/AdminPurchaseEntryNew.module.css"

const AmountSectionRepair = ({styles,register,invoice=false,gstCheckbox,TotalGst,TotalTaxableAmount,TotalBillAmount,setValue}) => {

  return (
    <div className={styles.calculationright}>
              <div className={styles.totalLeft}>
                <div className={styles.amountField}>
                  <label>Fine Metal</label>
                  <input
                  className={styes.PaymentSelect}
                  
                    type="text"
                    {...register("TotalFineMetal")}
                    disabled={true}
                    style={{border:'1px solid #ddd',backgroundColor:'#fff !important'}}
                  />
                </div>
                <div className={styles.amountField}>
                  <label>Paid Metal</label>
                  <input
                   className={styes.PaymentSelect}
                    type="text"
                    {...register("TotalPaidMetal")}
                    disabled={true}
                    style={{border:'1px solid #ddd',backgroundColor:'white !important'}}
                  />
                </div>

                <div className={styles.amountField}>
                  <label>Balance Metal</label>
                  <input
                   className={styes.PaymentSelect}
                    type="text"
                    {...register("TotalBalanceMetal")}
                    disabled={true}
                    style={{border:'1px solid #ddd',backgroundColor:'white !important'}}

                  />
                </div>
                <div className={styles.amountField}>
                  <label>Advance Amount</label>
                  <input
                   className={styes.PaymentSelect}
                    type="text"
                    {...register("TotalAdvanceAmount")}
                    disabled={true}
                    style={{border:'1px solid #ddd',backgroundColor:'white !important'}}

                  />
                </div>
                <div className={styles.amountField}>
                  <label>Courier Charge</label>
                  <input
                   className={styes.PaymentSelect}
                    type="number"
                    {...register("CourierCharge")}
                    // disabled={true}

                    style={{border:'1px solid #ddd',backgroundColor:'white !important'}}

                  />
                </div>
                <div className={styles.amountField}>
                  <label>Paid Amount</label>
                  <input
                   className={styes.PaymentSelect}
                    type="text"
                    {...register("TotalPaidAmount")}
                    disabled={true}
                    style={{border:'1px solid #ddd',backgroundColor:'white !important'}}

                  />
                </div>
              </div>

              <div className={styles.totalRight}>
                <div className={styles.amountField}>
                  <label>Taxable Amount</label>
                  <input
                   className={styes.PaymentSelect}
                    type="text"
                    {...register("TotalTaxableAmount")}
                    disabled={true}
                    style={{border:'1px solid #ddd',backgroundColor:'white !important'}}

                  />
                </div>
                <div className={styles.amountField}>
                  <label style={{ display: "flex", alignItems: "center" }}>
                    <label>GST(18%)</label>
                    <input
                     className={styes.PaymentSelect}
                      type="checkbox"
                      id="gstCheckbox"
                      // disabled={!invoice}
                      style={{
                        width: "15px",
                        height: "15px",
                        border:"1px solid #ddd"
                        // cursor: "pointer",
                      }}
                      {...register("gstCheckbox")}
                    />
                    {/* <input
                     className={styes.PaymentSelect}
                      type="checkbox"
                      id="gstCheckbox"
                      style={{
                        width: "15px",
                        height: "15px",
                        border:"1px solid #ddd"
                      }}
                      
                      {...register("gstCheckboxConfirm")}
                    /> */}
                  </label>
                  <input
                   className={styes.PaymentSelect}
                    type="text"
                    disabled={true}
                    style={{border:'1px solid #ddd',backgroundColor:'white !important'}}

                    {...register("TotalGst")}
                  />
                </div>
                <div className={styles.amountField}>
                  <label style={{ display: "flex", alignItems: "center" }}>
                    {invoice ? (<label>TDS(0.1%)</label>):(<label>TCS(0.1%)</label>)}
                    <input
                     className={styes.PaymentSelect}
                      type="checkbox"
                      id="additionalTaxCheckbox"
                      // disabled={!invoice}
                      style={{
                        width: "15px",
                        height: "15px",
                        border:"1px solid #ddd"
                        // cursor: "pointer",
                      }}
                      {...register("additionalTaxCheckbox")}
                    />
                  </label>
                  <input
                   className={styes.PaymentSelect}
                    type="text"
                    disabled={true}
                    style={{border:'1px solid #ddd',backgroundColor:'white !important'}}

                    {...register("additionalTax")}
                  />
                </div>
                <div className={styles.amountField}>
                  <label>R.O./Discount(-)</label>
                  <input
                   className={styes.PaymentSelect}
                   step="0.01"
                    type="number"
                    {...register("TotalRODiscount")}
                    style={{border:'1px solid #ddd',backgroundColor:'#fff !important'}}

                    // disabled={true}
                  />
                </div>
                <div className={styles.amountField}>
                  <label>Total Amount</label>
                  <input
                   className={styes.PaymentSelect}
                    type="text"
                    disabled={false}
                    {...register("TotalBillAmount",
                    //   {
                    //   onChange:(e)=>{
                    //     const billAmount = +e.target.value || 0;
                    //     let diff =  ((+(TotalGst) || 0) + (+(TotalTaxableAmount) || 0)) - (+(billAmount) || 0)
                    //     let discount = diff/1.03
                    //     console.log(TotalTaxableAmount)
                    //     console.log(TotalGst)
                    //     console.log(discount)
                    //     setTimeout(()=>{
                    //       setValue("gstDiscout",(diff - discount))

                    //     },2000)
                    //    setTimeout(()=>{

                    //      setValue(
                    //        "TotalRODiscount", discount?.toFixed(2)  
                    //       )
                      
                    //     },3000)
                       
                        
                    //   }
                    // }
                  )}
                    style={{border:'1px solid #ddd',backgroundColor:'white !important'}}

                  />
                </div>
                <div className={styles.amountField}>
                  <label>Balance Amount</label>
                  <input
                   className={styes.PaymentSelect}
                    type="text"
                    disabled={true}
                    {...register("TotalBalanceAmount")}
                    style={{border:'1px solid #ddd',backgroundColor:'white !important'}}

                  />
                </div>
              </div>
            </div>
  )
}

export default AmountSectionRepair
